import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import './styles/app.scss';
import Main from './screens/Main';
import { store } from './store/config/configureStore';

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        <Main />
      </BrowserRouter>
    </Provider>
  );
}

export default App;
